import { Component, EventEmitter, Input, Output } from '@angular/core';
import 'brace/theme/dreamweaver';

@Component({
  selector: 'cc-simple-code-box',
  templateUrl: './simple-code-box.component.html',
  styleUrls: ['./simple-code-box.component.scss']
})
export class SimpleCodeBoxComponent {
  @Input() mode: string;
  @Input() content: string;
  @Input() title: string;
  @Output() codeChanged = new EventEmitter();

  constructor() {}

  onChange(code) {
    this.codeChanged.next(code);
  }
}
